import React, { useState, useEffect } from "react";
import "../Styles/Help.css";

const HelpResponse = () => {
  const [user] = useState(JSON.parse(localStorage.getItem("student")));

  const [data, setData] = useState([]);
  const [filteredData, setFilteredData] = useState([]);
  const [searchTerm, setSearchTerm] = useState("");

  const [loading, setLoading] = useState(true);
  const [error, setError] = useState("");

  // Pagination
  const [currentPage, setCurrentPage] = useState(1);
  const itemsPerPage = 9;

  useEffect(() => {
    const fetchHelpData = async () => {
      try {
        const response = await fetch(
          `${process.env.REACT_APP_ADMIN_BASE_URL}/api/get-help-desk`,
          {
            method: "POST",
            headers: { "Content-Type": "application/json" },
            body: JSON.stringify({ UID: user.student.UID }),
          }
        );

        const result = await response.json();
        if (!result.success) {
          setError(result.message || "Something went wrong");
          return setLoading(false);
        }

        setData(result.data);
        setFilteredData(result.data);
        setLoading(false);
      } catch (err) {
        setError("Server Error");
        setLoading(false);
      }
    };

    fetchHelpData();
  }, []);

  // ----------------------
  // SEARCH FUNCTION
  // ----------------------
  const handleSearch = (e) => {
    const term = e.target.value.toLowerCase();
    setSearchTerm(term);

    if (!term.trim()) {
      setFilteredData(data);
      setCurrentPage(1);
      return;
    }

    const filtered = data.filter(
      (item) =>
        item.name.toLowerCase().includes(term) ||
        item.email.toLowerCase().includes(term) ||
        item.subject.toLowerCase().includes(term) ||
        item.phone.includes(term)
    );

    setFilteredData(filtered);
    setCurrentPage(1);
  };

  // ----------------------
  // FORMAT DATE
  // ----------------------
  const formatDate = (dateString) =>
    new Date(dateString).toLocaleDateString("en-US", {
      year: "numeric",
      month: "short",
      day: "numeric",
      hour: "2-digit",
      minute: "2-digit",
    });

  // ----------------------
  // STATUS COLORS
  // ----------------------
  const getStatusClass = (status) =>
    ({
      open: "status-open",
      Pending: "status-pending",
      Resolved: "status-resolved",
      closed: "status-closed",
    }[status] || "status-open");

  // ----------------------
  // PAGINATION LOGIC
  // ----------------------
  const lastIndex = currentPage * itemsPerPage;
  const firstIndex = lastIndex - itemsPerPage;
  const currentItems = filteredData.slice(firstIndex, lastIndex);

  const totalPages = Math.ceil(filteredData.length / itemsPerPage);

  const goToPage = (page) => setCurrentPage(page);

  // ----------------------

  return (
    <div className="help-wrapper">
      {/* 🔹 LOADING */}
      {loading && <h2 className="loader">Loading...</h2>}

      {/* HEADER */}
      <div className="help-header">
        <h1 className="ps-heading">Help Desk Tickets</h1>
        <p className="ps-subtitle">Track and manage your submitted issues</p>

        {/* Search Box */}
        <input
          type="text"
          className="help-search-box"
          placeholder="Search by name, email, subject or phone..."
          value={searchTerm}
          onChange={handleSearch}
        />
      </div>

      {/* NO DATA */}
      {currentItems.length === 0 ? (
        <div className="no-data">
          <i className="fas fa-search"></i>
          <h3>No tickets found</h3>
          <p>Try adjusting your search term</p>
        </div>
      ) : (
        <>
          {/* TICKETS GRID */}
          <div className="cards-grid">
            {currentItems.map((ticket) => (
              <div key={ticket._id} className="ticket-card">
                <div className="ticket-header">
                  <div className="avatar">
                    {ticket.name
                      .split(" ")
                      .map((n) => n[0])
                      .join("")
                      .toUpperCase()}
                  </div>

                  <div>
                    <h3>{ticket.name}</h3>
                    <span className="date">{formatDate(ticket.createdAt)}</span>
                  </div>

                  <span
                    className={`ticket-status ${getStatusClass(ticket.status)}`}
                  >
                    {ticket.status.charAt(0).toUpperCase() +
                      ticket.status.slice(1)}
                  </span>
                </div>

                <div className="ticket-body">
                  <div className="subject-line">
                    <i className="fas fa-tag"></i> {ticket.subject}
                  </div>

                  <div className="ticket-description-cont">
                    <p className="description">{ticket.description}</p>
                  </div>
                </div>
              </div>
            ))}
          </div>

          {/* PAGINATION */}
          <div className="pagination">
            {[...Array(totalPages)].map((_, index) => (
              <button
                key={index}
                className={currentPage === index + 1 ? "active-page" : ""}
                onClick={() => goToPage(index + 1)}
              >
                {index + 1}
              </button>
            ))}
          </div>
        </>
      )}
    </div>
  );
};

export default HelpResponse;
